import { ChakraConfirmationDialog } from 'app/components/Dialogs';

interface DeleteRepresentativeDialogProps {
  open: boolean;
  onClose: () => void;
  handleAction: () => void;
}

export const DeleteRepresentativeDialog = ({
  open = false,
  onClose,
  handleAction,
}: DeleteRepresentativeDialogProps) => {
  return (
    <ChakraConfirmationDialog
      title="Delete Representative"
      actionButtonText="Delete"
      handleAction={handleAction}
      isOpen={open}
      onClose={onClose}
      message={<>Are you sure you want to delete this representative?</>}
    />
  );
};
